import React, { useEffect, useState } from "react";
import "./index.css";
import bannerImage from "../../assets/referrals-banner-img.png";
import { Modal } from "antd";
import EarnBaaiTokensModal from "./EarnBaaiTokensModal";
import exclamatoryIcon from "../../assets/logo/circle-exclamatory.png";
import check from "../../assets/logo/check.png";
import apiClient from "../../services/axiosInterceptor";
import { plugin_url } from "../../config";

const MyReferralsBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [userTaskProgressDetails, setUserTaskProgressDetails] = useState({});

  const fetchTaskList = async () => {
    try {
      const { data } = await apiClient.get(`${plugin_url}/plugin/api/task`);
      setUserTaskProgressDetails(data);
    } catch (error) {
      console.log(error.message);
    }
  };
  useEffect(() => {
    fetchTaskList();
  }, []);
  console.log(userTaskProgressDetails);

  return (
    <section>
      {userTaskProgressDetails.type === "verifiedUserTaskList" && (
        <div className="row my-referrals-bg mx-1 mb-4">
          <div className="col-lg-8 my-referrals-heading">
            <h1>
              <span>Earn</span> more BAAI tokens WHILE watching your{" "}
              <span>favourite YouTube Video</span>
            </h1>
            <div className="user-progress-card">
              <div className="progress-numbers-container">
                {userTaskProgressDetails?.tasks.map((data, index, orgArray) => (
                  <a
                    href={
                      data?.completed === false && "https://www.youtube.com"
                    }
                    target="_blank"
                    className="progress-numbers"
                  >
                    <div
                      style={{
                        background: `${
                          data?.completed === true ? "#FFDD52" : "fff"
                        }`,
                      }}
                      className="number-circle"
                    >
                      <h6>
                        {" "}
                        {data?.completed === true ? (
                          <img src={check} alt="" />
                        ) : (
                          index + 1
                        )}
                      </h6>
                    </div>

                    {index + 1 !== orgArray.length && (
                      <div
                        style={{
                          border: `1px solid ${
                            data?.completed === true ? "#FFDD52" : "#fff"
                          }`,
                        }}
                        className="progress-line "
                      ></div>
                    )}

                    <p>{data?.task}</p>
                    <small>and earn {data?.point} points </small>
                  </a>
                ))}
              </div>

              <div className="task-details">
                <div>
                  <p>
                    <img src={exclamatoryIcon} alt="" /> Complete all of the
                    above tasks to earn bonus rewards
                  </p>
                </div>

                <div className="streak-days">
                  <p>
                    {userTaskProgressDetails?.streak}{" "}
                    {userTaskProgressDetails?.streak > 1 ? "Days" : "Day"}{" "}
                    Streak
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 d-flex justify-content-end align-items-end my-referrals-left-section">
            <img className="w-100" src={bannerImage} alt="" />
          </div>
        </div>
      )}
      <Modal
        className="earn-baai-tokens-modal"
        centered
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <EarnBaaiTokensModal handleClose={handleCancel} />
      </Modal>
    </section>
  );
};

export default MyReferralsBanner;
